import {
  getResourceById,
  GetResourceByIdRequestParams,
} from "@/requests/libraries/get-resource-by-id.request";
import { useQuery } from "@tanstack/react-query";

export const useResourceById = (params: GetResourceByIdRequestParams) => {
  return useQuery({
    queryKey: [
      "companies",
      params.companyId,
      "resource-libraries",
      params.resourceLibraryId,
      "resources",
      params.resourceId,
    ],
    queryFn: () => getResourceById(params),
    enabled:
      !!params.companyId && !!params.resourceLibraryId && !!params.resourceId,
  });
};
